"use strict";
// Copied from https://github.com/reach/reach-ui/blob/develop/packages/utils/src/clone-valid-element.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneValidElement = void 0;
const react_1 = require("react");
/**
 * Type-safe clone element
 *
 * @param element
 * @param props
 * @param children
 */
function cloneValidElement(element, props, ...children) {
    return (0, react_1.isValidElement)(element) ? (0, react_1.cloneElement)(element, props, ...children) : element;
}
exports.cloneValidElement = cloneValidElement;
//# sourceMappingURL=clone-valid-element.js.map